// extracted by mini-css-extract-plugin
module.exports = {"button":"arrowButton_button__8X1Ph","arrows":"arrowButton_arrows__OG7II","hide":"arrowButton_hide__70KHn"};